import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { EmployerStatsSummary } from "../../types/Stats";

export const getMyEmployerSummaryStats = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["employerSummaryStats"],
    queryFn: (): Promise<EmployerStatsSummary> => {
      return fetchWithAuth<EmployerStatsSummary>(
        "getMyEmployerSummaryStats",
        undefined
      );
    },
    enabled: isQueryEnabled(options),
  });
};
